import { render } from "./Plant.vue?vue&type=template&id=4eab464c&scoped=true"
import script from "./Plant.vue?vue&type=script&lang=js"
export * from "./Plant.vue?vue&type=script&lang=js"

import "./Plant.vue?vue&type=style&index=0&id=4eab464c&scoped=true&lang=css"
import "./Plant.vue?vue&type=style&index=1&id=4eab464c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eab464c"]])

export default __exports__